import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BreadcrumbsItem } from '@atlassian/mpac-navigation';
import { Route } from '@atlassian/mpac-ui';
import { UrlUtils } from '@atlassian/mpac-utils';
import React, { PureComponent } from 'react';
import { Switch } from 'react-router';
import { ANALYTICS_SUBJECT_ID_MANAGE } from '../../../analytics/Events';
import { manageAppDetailsRoute, manageRoute } from '../../../constants/Routes';
import ManageAppDetails from './ManageAppDetails';
import ManageApps from './ManageApps';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class ManageAppsRoutes extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onBreadcrumbsItemClick", e => {
      e.preventDefault();
      this.props.history.push({
        pathname: manageRoute.path
      });
    });
    _defineProperty(this, "render", () => /*#__PURE__*/_jsx(BreadcrumbsItem, {
      actionSubjectId: ANALYTICS_SUBJECT_ID_MANAGE,
      onClick: this.onBreadcrumbsItemClick,
      href: manageRoute.path,
      text: "Manage apps",
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: UrlUtils.joinPathNames([this.props.mountPath, manageRoute.path]),
          render: routeProps => /*#__PURE__*/_jsx(ManageApps, {
            bootstrapConfig: this.props.bootstrapConfig,
            currentUserId: this.props.currentUserId,
            history: routeProps.history,
            hostConfig: this.props.hostConfig,
            links: this.props.links,
            onRendered: this.props.onRendered,
            selectedContext: this.props.selectedContext
          })
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: UrlUtils.joinPathNames([this.props.mountPath, manageAppDetailsRoute.path]),
          render: routeProps =>
          /*#__PURE__*/
          _jsx(ManageAppDetails, {
            bootstrapConfig: this.props.bootstrapConfig,
            currentUserId: this.props.currentUserId,
            history: routeProps.history,
            hostConfig: this.props.hostConfig,
            links: this.props.links,
            location: routeProps.location,
            match: routeProps.match,
            onRendered: this.props.onRendered,
            selectedContext: this.props.selectedContext
          })
        })]
      })
    }));
  }
}
export default ManageAppsRoutes;